import React, {Component} from 'react';
import {DatePicker, Form, Icon} from "antd";
import moment from 'moment';
const {  RangePicker } = DatePicker;

class TaskTime extends Component {
    constructor(props) {
        super(props);
        this.state={
            startTime: props.itemValue&&props.itemValue[0]?props.itemValue[0]: null,
            endTime: props.itemValue&&props.itemValue[1]?props.itemValue[1]: null
        }
    }
    componentDidMount() {
    }
    render() {

        return (
                <Form.Item label={this.props.label} required={this.props.required} style={{display:"flex",alignItems:"center",width:"50%"}}  labelCol={{ span: 5 }} wrapperCol={{ span: 20 }}>
                    <RangePicker
                        style={{width:"280px"}}
                        showTime
                        className={'TaskTime'}
                        format="YYYY-MM-DD HH:mm"
                        disabledDate={(current)=>{
                            return current && current < moment().subtract(1, 'days').endOf('day')
                        }}
                        value={[this.state.startTime?moment(this.state.startTime):undefined,
                            this.state.endTime?moment(this.state.endTime):undefined]}
                        suffixIcon={<Icon type="clock-circle" />}
                        placeholder={this.props.placeholder}
                        onChange={(data,date)=>{
                            let startTime = data[0]?data[0].valueOf():null;
                            let endTime = data[1]?data[1].valueOf():null;
                            this.setState({
                                startTime,
                                endTime
                            },()=>{
                                this.props.callBack&&this.props.callBack([startTime,endTime])
                            });


                    }}/>
                    <style>{`.TaskTime .ant-input{background: rgba(0, 80, 179, 0.04)}
                             .TaskTime .ant-input .ant-calendar-range-picker-input{text-align: left}
                    `}</style>
                </Form.Item>
        );
    }
}



export default TaskTime;